import { BlocksLayoutContainer } from 'blocks-nextjs/blocks-web-components/components/layout-container/layout-container';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatLayoutContainer = createComponent({ react: React, tagName: 'cat-layout-container', elementClass: BlocksLayoutContainer });
